const MAP_KEY_PREFIX = "cs_";

// react-hook-form would turn bare numeric keys into sparse array indexes, hence the prefix.
export const curriculumStudyGroupsMapKey = curriculumId => `curriculumStudyGroupsMap.${MAP_KEY_PREFIX}${curriculumId}`;

// Enforces the BE XOR contract on a slot (create) or the whole schedule (edit): either the
// shared studyGroups string travels, or curriculumStudyGroups entries do — never both.
// Strips the UI-only perCurriculumStudyGroups flag and the curriculumStudyGroupsMap fields.
// An empty map entry means ALL groups of that curriculum, so it is omitted from the payload;
// entries for curricula that were deselected after typing are dropped as well.
export const normalizeStudyGroupsPayload = (values, curriculumIds = values.curriculumIds ?? []) => {
  const { perCurriculumStudyGroups, curriculumStudyGroupsMap, curriculumStudyGroups, ...rest } = values;

  if (!perCurriculumStudyGroups || curriculumIds.length === 0) return rest;

  const selectedIds = new Set(curriculumIds);

  return {
    ...rest,
    studyGroups: "",
    curriculumStudyGroups: Object.entries(curriculumStudyGroupsMap || {})
      .filter(([, studyGroups]) => studyGroups?.trim())
      .map(([key, studyGroups]) => ({
        curriculumId: Number(key.slice(MAP_KEY_PREFIX.length)),
        studyGroups,
      }))
      .filter(entry => selectedIds.has(entry.curriculumId)),
  };
};

// The inverse, for the edit form: the for-update response carries curriculumStudyGroups[]
// when the per-curriculum sets diverge; expose them as map fields + the mode flag.
export const hydrateStudyGroupsForm = data => ({
  ...data,
  perCurriculumStudyGroups: (data?.curriculumStudyGroups?.length ?? 0) > 0,
  curriculumStudyGroupsMap: Object.fromEntries(
    (data?.curriculumStudyGroups ?? []).map(entry => [`${MAP_KEY_PREFIX}${entry.curriculumId}`, entry.studyGroups]),
  ),
});
